/* eslint-disable no-var */

// require('react')
import './src/styles/fonts.css'
import Plyr from 'plyr'
window.Plyr = Plyr
